"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Services_1 = require("../../../../../../../Services");
var UprcFilter = /** @class */ (function (_super) {
    __extends(UprcFilter, _super);
    function UprcFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.search = function () {
            var _a;
            var uprc = (_a = _this.uprcInput.current) === null || _a === void 0 ? void 0 : _a.value;
            if (Services_1.isNullOrWhiteSpace(uprc)) {
                _this.setState({ uprcIsInvalid: true });
            }
            else {
                _this.props.fetchResults({
                    uprc: uprc
                });
            }
        };
        _this.uprcInput = React.createRef();
        _this.state = {
            uprcIsInvalid: false
        };
        return _this;
    }
    UprcFilter.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, { style: { alignItems: "center" } },
            React.createElement(reactstrap_1.Col, null,
                React.createElement(reactstrap_1.InputGroup, null,
                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                        React.createElement(reactstrap_1.InputGroupText, null, this.props.resources.UPRC)),
                    React.createElement(reactstrap_1.Input, { innerRef: this.uprcInput, invalid: this.state.uprcIsInvalid, onChange: function () { if (_this.state.uprcIsInvalid) {
                            _this.setState(__assign(__assign({}, _this.state), { uprcIsInvalid: false }));
                        } } }),
                    this.state.uprcIsInvalid && React.createElement(reactstrap_1.FormFeedback, null, this.props.resources.Registration_Validation_RequiredField))),
            React.createElement(reactstrap_1.Col, { xs: "auto", style: { display: "flex", justifyContent: "center", alignItems: "center" } },
                React.createElement(reactstrap_1.Button, { size: "lg", outline: true, color: "primary", onClick: this.search },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch })))));
    };
    return UprcFilter;
}(React.Component));
exports.UprcFilter = UprcFilter;
//# sourceMappingURL=UprcFilter.js.map